export default __webpack_public_path__ + "static/media/dramatic.39a1ddab.mp3";